import React, { Component } from 'react'
import { slide as MenuSlide } from 'react-burger-menu'
import { withStyles } from '@material-ui/core/styles';

import { Link } from 'react-router-dom'
import { isMobileApp } from '@/utils/MobileAppUserAgentChecker';

const styles = {
    switchBase: {
        color: "#f8f8f8",
        '&$checked': {
            color: "#8bc541",
        },
        '&$checked + $track': {
            backgroundColor: "#8bc541",
        },
    },
    bar: {
        color: "#8bc541"
    },
    icon: {
        backgroundColor: "#f8f8f8",
    },
    iconChecked: {
        backgroundColor: "#8bc541",
        "&$bar": {
            backgroundColor: "#8bc541",
        },
    },
}
class Menu extends Component {


    constructor(props) {
        super(props)

        this.state = {
            isOpen: false
        }
    }





    handleMenuStateChange = ({ isOpen }) => {
        this.setState({ isOpen })
    }

    handleFAQClick=(e)=>{
        e.preventDefault();
        this.setState({ isOpen:false })
        // window.open('https://video09.zendesk.com/hc/ko', '_blank')
    }


    handleOpenChanelIO=(e)=>{
        e.preventDefault();
        if (window.ChannelIO) window.ChannelIO('show')
    }

    render() {
        const { isOpen } = this.state;

        return (
            <div style={{ paddingRight: "16px" }}>
                <MenuSlide
                    className="mobile-menu"
                    isOpen={isOpen}
                    onStateChange={this.handleMenuStateChange}
                    right
                    overlayClassName="mobile-overlay"  
                    customBurgerIcon={
                        <img
                            src="https://front.videomonster.com/images-7cuytg20/web/mobile/burgermenu.svg"
                            alt=""
                        />
                    }
                >
                    <div className='menu-title'>
                        <p>영상제작 원스톱 솔루션</p>
                        <img src="https://front.videomonster.com/images-7cuytg20/mobile/video09/menu_logo.webp" alt='' />
                    </div>
                    <div className='item'>
                        <Link onClick={() => this.handleMenuStateChange({ isOpen: false })} to="/order/lookup">주문조회</Link>
                    </div>
                    <div className='item'>
                        <Link onClick={() => this.handleMenuStateChange({ isOpen: false })} to="/order">주문하기</Link>
                    </div>
                    <div className='item'>
                        <Link onClick={this.handleFAQClick} to="">FAQ</Link>
                    </div>
                    <div className='item'>
                        <Link onClick={this.handleOpenChanelIO} to="/">세금계산서 발행</Link>
                    </div>

                </MenuSlide>
            </div>
        )
    }
}


export default withStyles(styles)(Menu)